import { render } from "./OnCallSuperBtn.vue?vue&type=template&id=2175ebed"
import script from "./OnCallSuperBtn.vue?vue&type=script&lang=js"
export * from "./OnCallSuperBtn.vue?vue&type=script&lang=js"

import "./OnCallSuperBtn.vue?vue&type=style&index=0&id=2175ebed&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__